import { render } from "./PCWorkerRecords.vue?vue&type=template&id=319cddae"
import script from "./PCWorkerRecords.vue?vue&type=script&lang=js"
export * from "./PCWorkerRecords.vue?vue&type=script&lang=js"

import "./PCWorkerRecords.vue?vue&type=style&index=0&id=319cddae&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__